import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Text = styled(TextLayoutComponent)`
    color: black;
    font-size: 12px;
    font-weight: 500;
    margin-left: 20px;
`;

export {
  Text,
};
